// extracted by mini-css-extract-plugin
export default {"wrapper":"Kz-z","button":"Lz-z","alternate":"Mz-z","disabled":"Nz-z","paymentWarning":"Oz-z","fadeIn":"Pz-z"};